/**
 * NOT CHECKED
 */
import React from 'react';

import CampaignEmptyMessageSVG from '@uikit/old/StubIllustration/_components/CampaignEmptyMessageSVG';
import Button from '@uikit/Form/Button/Button';

import './StubIllustration.scss';

type CampaignsEmptyMessageType = {
  text: string;
  subText?: string;
  buttonText?: string;
  onClickButton: (e) => void;
  IllustrationSVG?: () => JSX.Element;
  isLoading?: boolean;
  buttonType?: any;
  buttonIcon?: any;
  colorIcon?: string;
  buttonSize?: any;
  textSize?: number;
  subTextSize?: number;
  maxTextSize?: number;
  /** data-testid on the root (ui-automation-tests). */
  testId?: string;
  /** data-testid on the button (ui-automation-tests). */
  buttonTestId?: string;
};

const StubIllustration = ({
  text,
  subText,
  buttonText,
  onClickButton,
  IllustrationSVG,
  isLoading,
  buttonType,
  buttonIcon,
  colorIcon,
  buttonSize,
  textSize,
  subTextSize,
  maxTextSize,
  testId,
  buttonTestId,
}: CampaignsEmptyMessageType) => (
  <div className="campaigns-empty-message" data-testid={testId}>
    {IllustrationSVG ? <IllustrationSVG /> : <CampaignEmptyMessageSVG />}

    <div
      className="campaigns-empty-message__message"
      style={{ fontSize: `${textSize}px`, maxWidth: `${maxTextSize}px` }}
    >
      {text}
    </div>
    <div className="campaigns-empty-message__sub-message" style={{ fontSize: `${subTextSize}px` }}>
      {subText}
    </div>

    {buttonText ? (
      <Button
        isLoading={isLoading}
        loadingText="Loading..."
        onClick={onClickButton}
        className="campaigns-empty-message__link"
        type={buttonType}
        rightIcon={buttonIcon}
        colorIcon={colorIcon}
        size={buttonSize}
        data-testid={buttonTestId}
      >
        {buttonText}
      </Button>
    ) : null}
  </div>
);

export default StubIllustration;
